import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, MenuItem, InputLabel, FormControl, Alert } from '@mui/material';
import { ApiTokenInterface } from '../../../interfaces/interfaces';

interface Props {
  open: boolean;
  tokenToUpdate: ApiTokenInterface | null;
  setTokenToUpdate: React.Dispatch<React.SetStateAction<ApiTokenInterface | null>>;
  onClose: () => void;
  onSave: () => void;
  updateError?: string | null;
  updateSuccess?: string | null;
}

export const AdSpaceApiTokensUpdateDialog: React.FC<Props> = ({
  open,
  tokenToUpdate,
  setTokenToUpdate,
  onClose,
  onSave,
  updateError,
  updateSuccess,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Update API Token</DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      {updateError && <Alert severity="error">{updateError}</Alert>}
      {updateSuccess && <Alert severity="success">{updateSuccess}</Alert>}
      <TextField
        label="User ID"
        type="number"
        value={tokenToUpdate?.userId ?? ''}
        onChange={e => setTokenToUpdate(p => p ? { ...p, userId: Number(e.target.value) } : p)}
        fullWidth
        margin="dense"
        required
      />
      <FormControl fullWidth margin="dense">
        <InputLabel id="active-label">Active</InputLabel>
        <Select
          labelId="active-label"
          value={tokenToUpdate?.active !== undefined ? (tokenToUpdate.active ? 'yes' : 'no') : 'yes'}
          label="Active"
          onChange={e => setTokenToUpdate(p => p ? { ...p, active: e.target.value === 'yes' } : p)}
        >
          <MenuItem value="yes">Yes</MenuItem>
          <MenuItem value="no">No</MenuItem>
        </Select>
      </FormControl>
      <TextField
        label="Valid Until"
        type="datetime-local"
        value={tokenToUpdate?.validUntil ? new Date(tokenToUpdate.validUntil).toISOString().slice(0, 16) : ''}
        onChange={e => setTokenToUpdate(p => p ? { ...p, validUntil: new Date(e.target.value) } : p)}
        fullWidth
        margin="dense"
        required
        InputLabelProps={{ shrink: true }}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button color="primary" onClick={onSave}>Save</Button>
    </DialogActions>
  </Dialog>
);